async function referenceDateCheck(newData, oldData) {
  return newData.referenceDate !== oldData.referenceDate;
}
exports.referenceDateCheck = referenceDateCheck;
